import "../css/ZoomButtons.css";
import { useDarkMode } from "../context/darkModeContext";

const ZoomButtons = ({
  setZoom,
}: {
  setZoom: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { darkMode } = useDarkMode();
  return (
    <div className="container">
      <div className="zoom-buttons--wrapper">
        <div className="zoom-buttons">
          <div
            onClick={() => setZoom((prev) => prev + 1)}
            className={
              darkMode
                ? "zoom-button--darkmode zoom-button-border--darkmode"
                : "zoom-button zoom-button--border"
            }
          >
            +
          </div>
          <div
            onClick={() => setZoom((prev) => prev - 1)}
            className={darkMode ? "zoom-button--darkmode" : "zoom-button"}
          >
            -
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoomButtons;
